module.exports = __webpack_public_path__ + "media/images/amenities_icons/vrc_equipment-2bba66ab8544358f2073f1334bf66640.svg";